var indentation_default = {
  "indentZero": "BqjLQ",
  "indentOne": "xY20Z",
  "indentTwo": "-kTXR",
  "indentThree": "iZeym",
  "indentFour": "_2dorK",
  "indentFive": "_4ECo-",
  "indentSix": "Fz-6x"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
